import { DateTime } from 'luxon';

export const formatDate = (
  date?: string,
  format = 'MMMM d',
  localTimezone = false,
  // TODO: Uncomment these options when needed
  // showDayOfWeek = false, // Show full day name for nearby dates
  // showToday = false, // Whether to show "Today" for today's date
  // showTomorrow = false // Whether to show "Tomorrow" for tomorrow's date
) => {
  if (!date) return '';
  let dateTime = DateTime.fromISO(date, { zone: 'utc' });

  // Convert to local timezone if needed
  if (localTimezone) {
    const localZone = DateTime.local().zoneName;
    dateTime = dateTime.setZone(localZone);
  }

  // TODO: Uncomment this block when needed
  // const now = DateTime.local();

  // Optionally show "Today"
  // if (showToday && dateTime.hasSame(now, 'day')) {
  //   return 'Today';
  // }

  // Optionally show "Tomorrow"
  // if (showTomorrow && dateTime.hasSame(now.plus({ days: 1 }), 'day')) {
  //   return 'Tomorrow';
  // }

  // Check if we want to show the day of the week and if the date is within the next 7 days
  // const daysDiff = dateTime.diff(now, 'days').days;
  // if (showDayOfWeek && daysDiff > 0 && daysDiff <= 7) {
  //   return dateTime.toFormat('cccc'); // Full day name (e.g., "Monday")
  // }

  // If it's further than 7 days away, or we don't want to show the day name, return the formatted date
  return dateTime.toFormat(format);
};

export const formatTime = (
  date?: string,
  timeFormat?: string,
  shortFormat = false,
  localTimezone = false,
) => {
  if (!date) return '';
  const format = timeFormat || 'h:mma';
  let dateTime = DateTime.fromISO(date, { zone: 'utc' });
  if (localTimezone) dateTime = dateTime.setZone(DateTime.local().zoneName);
  const adjustedFormat = shortFormat && dateTime?.minute === 0 && format === 'h:mma' ? 'ha' : format;

  return dateTime?.toFormat(adjustedFormat).toLowerCase() || '';
};
